<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003601.installation.preventionBacterie.titre' | translate"
      [description]="
        'P0003601.installation.preventionBacterie.description' | translate
      "
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="
        'P0003601.installation.prevention.filtrationForceeEauChaude2424'
          | translate
      "
      [nameCustom]="
        'P0003601.installation.prevention.activationFonctionFiltration2424.smallTitle'
          | translate
      "
      [value]="actionStack!.getValue('fvsPActivationFonction2424') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationVS_Parametrage4,
          'fvsPActivationFonction2424',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (actionStack!.getValue('fvsPActivationFonction2424') === 1) {
      <app-label-configuration
        [titleListe]="
          'P0003601.installation.prevention.seuilTemperatureFonctionFiltration2424.smallTitle'
            | translate
        "
        [value]="actionStack!.getValue('fvsPSeuilTemperature2424')"
        [liste]="P0003601SeuilTemperatureFiltration2424()"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.FiltrationVS_Parametrage2,
            'fvsPSeuilTemperature2424',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="
        'P0003601.installation.prevention.activationFonctionFiltration2424.description.' +
          getTemperatureType() | translate
      "
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
